import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@nike/eds/dist/index.css';
import { BrowserRouter } from 'react-router-dom';
import { logPageAction } from './newrelic';

const CHUNK_RELOAD_KEY = 'passplay-chunk-reload';

const isChunkLoadFailure = (error: unknown): boolean => {
  if (!error) {
    return false;
  }
  const err = error as Error;
  if (err.name === 'ChunkLoadError') {
    return true;
  }
  return /Loading (CSS )?chunk [\w-]+ failed/i.test(err.message ?? '');
};

const handleChunkLoadFailure = () => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    return;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
};

window.addEventListener('unhandledrejection', event => {
  if (!isChunkLoadFailure(event.reason)) {
    return;
  }
  event.preventDefault();
  handleChunkLoadFailure();
});

window.addEventListener(
  'error',
  event => {
    const target = event.target as HTMLElement | null;
    if (target && (target.tagName === 'LINK' || target.tagName === 'SCRIPT')) {
      handleChunkLoadFailure();
      return;
    }
    if (isChunkLoadFailure(event.error)) {
      handleChunkLoadFailure();
    }
  },
  true,
);

if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
  window.addEventListener('load', () => {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals(({ name, value, id }) => {
  logPageAction('WebVital', {
    metricName: name,
    value: Math.round(name === 'CLS' ? value * 1000 : value),
    id,
  });
});
